import { createAction, props } from '@ngrx/store';
import { IOpenedPrintOptionsAccordions } from '../interfaces/opened-print-options-accordions.interface';

export const onSetUser = createAction('[Aumico-App] onSetUser', props<{ payload: string }>());

export const onSetUploadedFileChanged = createAction(
    '[Aumico-App] onSetUploadedFileChanged',
    props<{ payload: boolean }>(),
);

export const onSetSupportOperation = createAction('[Aumico-App] onSetSupportOperation', props<{ payload: boolean }>());

export const onSetOpenedPrintOptionsAccordions = createAction(
    '[Aumico-App] onSetOpenedPrintOptionsAccordions',
    props<{ payload: IOpenedPrintOptionsAccordions }>(),
);

export const flushState = createAction('[Aumico-App] Flush State');

export type TestActions = typeof onSetUser;
